export default __webpack_public_path__ + "static/GT-Super-Display-Regular-Italic-f524a021a674d2772cf7927cfd606c3e.woff";